module.exports = __webpack_public_path__ + "img/0Q3A8493_L_Wood.10882b33.jpg";